import { render, staticRenderFns } from "./BatchTransactionHistory.vue?vue&type=template&id=670e8dfc&scoped=true&"
import script from "./BatchTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./BatchTransactionHistory.vue?vue&type=script&lang=js&"
import style0 from "./BatchTransactionHistory.vue?vue&type=style&index=0&id=670e8dfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e8dfc",
  null
  
)

export default component.exports